import React from "react"

import CallCenterImg from "@shared/assets/images/img-call.png"

export default function CallCenter() {
  return (
    <div className="csB">
      <img src={CallCenterImg} height={48} />
    </div>
  )
}
